import React from "react";

const DropdownModel = ({ list, selectHandler, elvalue, label, required }) => {
  return (
    <div className="w-full space-y-2">
      {label && (
        <label 
          htmlFor="model-select"
          className="block text-sm font-semibold text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <div className="relative">
        <select 
          value={elvalue}
          name="model-select"
          id="model-select"
          className="w-full py-3 px-4 pr-12 text-base font-normal text-gray-800 
                   bg-white border border-gray-300 rounded-xl
                   shadow-sm outline-none transition-all duration-200
                   appearance-none cursor-pointer
                   hover:border-blue-400 hover:shadow-md
                   focus:border-blue-500 focus:ring-3 focus:ring-blue-100 focus:shadow-lg
                   active:border-blue-500
                   disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
          onChange={selectHandler}
        >
          {list.map((item, i) => (
            <option 
              value={item} 
              key={item + i}
              className="py-2 text-gray-700 font-normal hover:bg-blue-50"
            >
              {item}
            </option>
          ))}
        </select>
        
        {/* Custom dropdown arrow */}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
          <svg 
            className="h-5 w-5 transition-transform duration-200" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DropdownModel;